import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { idLikeSchema } from '@zaoblako/shared/modules/serde/schemas/id-like.schema';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';

import * as yup from 'yup';

/** Currency create and update APIs request body - DTO signature */
export interface CurrencyFormInterface {
  /** Currency name in Russian */
  name: string;
  /** Currency name in English */
  nameEnglish: string;
  /** Currency denomination (need for rate calculation) */
  denomination?: number;
  /** Currency ISO-4217 numeric code */
  isoNumeric: string;
  /** Currency ISO-4217 character code */
  isoCharacter: string;
}

/** Currency create and update APIs request body - DTO schema */
export const CurrencyFormDto = SerdeDtoClass.create<CurrencyFormInterface>(CatalogDtosKeysEnum.CURRENCY_FORM_DTO, {
  name: {
    sortable: true,
    label: 'Название на русском',
    serializer: nonEmptyStringSchema,
  },
  nameEnglish: {
    sortable: true,
    label: 'Название на английском',
    serializer: nonEmptyStringSchema,
  },
  denomination: {
    optional: true,
    default: 1,
    label: 'Номинал',
    serializer: idLikeSchema,
  },
  isoNumeric: {
    sortable: true,
    label: 'Цифровой код валюты согласно стандарту ISO-4217',
    checkers: [CatalogCheckersEnum.CURRENCY_ISO_NUMERIC_UNIQUE],
    serializer: yup
      .string()
      .matches(/^\d{3}$/m, 'Цифровой код валюты согласно стандарту ISO-4217 должен состоять из трех цифр'),
  },
  isoCharacter: {
    sortable: true,
    label: 'Символьный код валюты согласно стандарту ISO-4217',
    checkers: [CatalogCheckersEnum.CURRENCY_ISO_CHARACTER_UNIQUE],
    serializer: yup
      .string()
      .matches(/^[A-Z]{3}$/m, 'Символьный код валюты согласно стандарту ISO-4217 должен состоять из трех заглавных латинских букв'),
  },
});
